import React from "react";
import ModalForm from "@ui/Modal/Form";
import t from "../../../../i18n";
import { useDelete } from "../../../../api/useCall";
import Text from "@ui/Text";

interface ModalFormDeleteLinkProps {
  externalLinkId: string;
  externalLinkName: string;
  onRequestClose: () => void;
}

export const ModalFormDeleteLink = ({
  externalLinkId,
  externalLinkName,
  onRequestClose,
}: ModalFormDeleteLinkProps) => {
  const deleteExternalLink = useDelete("/externalLinks/:linkId(uuid)");

  const handleSubmit = React.useCallback(async () => {
    await deleteExternalLink({
      routeParams: { linkId: externalLinkId },
    });
    onRequestClose();
    return true;
  }, [deleteExternalLink, externalLinkId, onRequestClose]);

  return (
    <ModalForm
      onSubmit={handleSubmit}
      onRequestClose={onRequestClose}
      okButtonVariant="destructive"
      okButtonName={t("modalForm.button.name.delete")}
    >
      <Text>
        {t(
          "app.administration.application.link.modal.form.delete.content",
          <Text type="body1SemiBold" as="span">
            {externalLinkName}
          </Text>,
        )}
      </Text>
    </ModalForm>
  );
};
